import { render } from "./cluePool.vue?vue&type=template&id=4cb45ad7&scoped=true"
import script from "./cluePool.vue?vue&type=script&lang=js"
export * from "./cluePool.vue?vue&type=script&lang=js"

import "./cluePool.vue?vue&type=style&index=0&id=4cb45ad7&scoped=true&lang=css"
import "./cluePool.vue?vue&type=style&index=1&id=4cb45ad7&lang=css"
script.render = render
script.__scopeId = "data-v-4cb45ad7"

export default script